import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Reloads the whole page once, as soon as this element connects. Render it into a polled frame
// when the background work finishes, so the rest of the page (not just the frame) shows the result.
export default class extends Controller {
  connect() {
    Turbo.visit(window.location.href, { action: "replace" })
  }
}
